import GamePlayImage from "./assets/GameRules/mines-gameplay.png";
import CollectImage from "./assets/GameRules/mines-collect.png";
import BombImage from "./assets/GameRules/mines-bomb.png";
import styled from "styled-components";

const MultiplierTable = styled.table`
    width: 100%;
    text-align: left;
    border: 2px solid white;
    border-collapse: collapse;

    tr {
        border-bottom: 1px solid white;
    }

    td {
        padding: 3px;
        font-variant-numeric: tabular-nums;
        width: 50%;
    }
    
    th {
        padding: 3px;
    }
`;

export const GameRules =
    <div>
        <h3>Mines</h3>
        <p><strong>RTP:</strong> 95%</p>
        <em>Select your cells to uncover dazzling diamonds and watch your step for deadly Mines</em>
        <p>Click each cell to uncover a cash prize added to your total round winnings. Collect at any time to secure your winnings and watch out as a Mine will forfeit your round prizes.</p>
        <center><img style={{ width: "50%" }} src={GamePlayImage} /></center>
        <h3>The game</h3>
        <em>Collect your winnings at any time or power on for the chance to increase your winnings</em>
        <center><img style={{ width: "50%" }} src={CollectImage} /></center>
        <p>Careful, as uncovering a Mine will forfeit your winnings and end the round</p>
        <p>The maximum multiplier attainable in a single game round is 4940285.0000x</p>
        <center><img style={{ width: "50%" }} src={BombImage} /></center>
        <h3>Game rules</h3>
        <ul>
            <li>To begin, press the PLAY button</li>
            <li>Pressing the END button will end the game without wagering</li>
            <li>Using the Bet button, the player's bet can be changed</li>
            <li>On any round, players can either pick a space on the grid or press COLLECT to collect their current prize value</li>
            <li>If the player reveals a winning symbol, the prize is increased and the game continues</li>
            <li>If the player reveals a Mine symbol, the prize value is forfeit and the round resets</li>
            <li>Players can also use the Pick Random Cell button to randomly pick any available space on the board at random</li>
            <li>The prize value is displayed on the Collect button at the bottom of the play board</li>
            <li>Players can select Collect at any time to secure their current unlocked winnings</li>
            <li>Prize values are dependent on bet value and the number of active Mines (2-24) </li>
            <li>Players can set the number of active Mines at the beginning of each new round</li>
        </ul>

        <h3>Multipliers</h3>
        <em>All winnings are rounded down when the stake is multiplied by the multipliers below</em>
        <h4>2 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>1.0326</td><td>1</td></tr>
            <tr><td>1.1265</td><td>2</td></tr>
            <tr><td>1.2338</td><td>3</td></tr>
            <tr><td>1.3571</td><td>4</td></tr>
            <tr><td>1.5000</td><td>5</td></tr>
            <tr><td>1.6667</td><td>6</td></tr>
            <tr><td>1.8627</td><td>7</td></tr>
            <tr><td>2.0956</td><td>8</td></tr>
            <tr><td>2.3750</td><td>9</td></tr>
            <tr><td>2.7143</td><td>10</td></tr>
            <tr><td>3.1319</td><td>11</td></tr>
            <tr><td>3.6538</td><td>12</td></tr>
            <tr><td>4.3182</td><td>13</td></tr>
            <tr><td>5.1818</td><td>14</td></tr>
            <tr><td>6.3333</td><td>15</td></tr>
            <tr><td>7.9167</td><td>16</td></tr>
            <tr><td>10.1786</td><td>17</td></tr>
            <tr><td>13.5714</td><td>18</td></tr>
            <tr><td>19.0000</td><td>19</td></tr>
            <tr><td>28.5000</td><td>20</td></tr>
            <tr><td>47.5000</td><td>21</td></tr>
            <tr><td>95.0000</td><td>22</td></tr>
            <tr><td>285.0000</td><td>23</td></tr>
        </MultiplierTable>

        <h4>3 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>1.0795</td><td>1</td></tr>
            <tr><td>1.2338</td><td>2</td></tr>
            <tr><td>1.4188</td><td>3</td></tr>
            <tr><td>1.6429</td><td>4</td></tr>
            <tr><td>1.9167</td><td>5</td></tr>
            <tr><td>2.2549</td><td>6</td></tr>
            <tr><td>2.6777</td><td>7</td></tr>
            <tr><td>3.2132</td><td>8</td></tr>
            <tr><td>3.9018</td><td>9</td></tr>
            <tr><td>4.8022</td><td>10</td></tr>
            <tr><td>6.0027</td><td>11</td></tr>
            <tr><td>7.6399</td><td>12</td></tr>
            <tr><td>9.9318</td><td>13</td></tr>
            <tr><td>13.2424</td><td>14</td></tr>
            <tr><td>18.2083</td><td>15</td></tr>
            <tr><td>26.0119</td><td>16</td></tr>
            <tr><td>39.0179</td><td>17</td></tr>
            <tr><td>62.4286</td><td>18</td></tr>
            <tr><td>109.2500</td><td>19</td></tr>
            <tr><td>218.5000</td><td>20</td></tr>
            <tr><td>546.2500</td><td>21</td></tr>
            <tr><td>2185.0000</td><td>22</td></tr>
        </MultiplierTable>

        <h4>4 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>1.1310</td><td>1</td></tr>
            <tr><td>1.3571</td><td>2</td></tr>
            <tr><td>1.6429</td><td>3</td></tr>
            <tr><td>2.0079</td><td>4</td></tr>
            <tr><td>2.4804</td><td>5</td></tr>
            <tr><td>3.1005</td><td>6</td></tr>
            <tr><td>3.9273</td><td>7</td></tr>
            <tr><td>5.0494</td><td>8</td></tr>
            <tr><td>6.6030</td><td>9</td></tr>
            <tr><td>8.8040</td><td>10</td></tr>
            <tr><td>12.0055</td><td>11</td></tr>
            <tr><td>16.8077</td><td>12</td></tr>
            <tr><td>24.2778</td><td>13</td></tr>
            <tr><td>36.4167</td><td>14</td></tr>
            <tr><td>57.2262</td><td>15</td></tr>
            <tr><td>95.3770</td><td>16</td></tr>
            <tr><td>171.6786</td><td>17</td></tr>
            <tr><td>343.3571</td><td>18</td></tr>
            <tr><td>801.1667</td><td>19</td></tr>
            <tr><td>2403.5000</td><td>20</td></tr>
            <tr><td>12017.5000</td><td>21</td></tr>
        </MultiplierTable>

        <h4>5 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>1.1875</td><td>1</td></tr>
            <tr><td>1.5000</td><td>2</td></tr>
            <tr><td>1.9167</td><td>3</td></tr>
            <tr><td>2.4804</td><td>4</td></tr>
            <tr><td>3.2555</td><td>5</td></tr>
            <tr><td>4.3407</td><td>6</td></tr>
            <tr><td>5.8909</td><td>7</td></tr>
            <tr><td>8.1567</td><td>8</td></tr>
            <tr><td>11.5553</td><td>9</td></tr>
            <tr><td>16.8077</td><td>10</td></tr>
            <tr><td>25.2115</td><td>11</td></tr>
            <tr><td>39.2179</td><td>12</td></tr>
            <tr><td>63.7292</td><td>13</td></tr>
            <tr><td>109.2500</td><td>14</td></tr>
            <tr><td>200.2917</td><td>15</td></tr>
            <tr><td>400.5833</td><td>16</td></tr>
            <tr><td>901.3125</td><td>17</td></tr>
            <tr><td>2403.5000</td><td>18</td></tr>
            <tr><td>8412.2500</td><td>19</td></tr>
            <tr><td>50473.5000</td><td>20</td></tr>
        </MultiplierTable>

        <h4>6 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>1.2500</td><td>1</td></tr>
            <tr><td>1.6667</td><td>2</td></tr>
            <tr><td>2.2549</td><td>3</td></tr>
            <tr><td>3.1005</td><td>4</td></tr>
            <tr><td>4.3407</td><td>5</td></tr>
            <tr><td>6.2010</td><td>6</td></tr>
            <tr><td>9.0630</td><td>7</td></tr>
            <tr><td>13.5945</td><td>8</td></tr>
            <tr><td>21.0096</td><td>9</td></tr>
            <tr><td>33.6154</td><td>10</td></tr>
            <tr><td>56.0256</td><td>11</td></tr>
            <tr><td>98.0449</td><td>12</td></tr>
            <tr><td>182.0833</td><td>13</td></tr>
            <tr><td>364.1667</td><td>14</td></tr>
            <tr><td>801.1667</td><td>15</td></tr>
            <tr><td>2002.9167</td><td>16</td></tr>
            <tr><td>6008.7500</td><td>17</td></tr>
            <tr><td>24035.0000</td><td>18</td></tr>
            <tr><td>168245.0000</td><td>19</td></tr>
        </MultiplierTable>

        <h4>7 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>1.3194</td><td>1</td></tr>
            <tr><td>1.8627</td><td>2</td></tr>
            <tr><td>2.6777</td><td>3</td></tr>
            <tr><td>3.9273</td><td>4</td></tr>
            <tr><td>5.8909</td><td>5</td></tr>
            <tr><td>9.0630</td><td>6</td></tr>
            <tr><td>14.3497</td><td>7</td></tr>
            <tr><td>23.4813</td><td>8</td></tr>
            <tr><td>39.9183</td><td>9</td></tr>
            <tr><td>70.9658</td><td>10</td></tr>
            <tr><td>133.0609</td><td>11</td></tr>
            <tr><td>266.1218</td><td>12</td></tr>
            <tr><td>576.5972</td><td>13</td></tr>
            <tr><td>1383.8333</td><td>14</td></tr>
            <tr><td>3805.5417</td><td>15</td></tr>
            <tr><td>12685.1389</td><td>16</td></tr>
            <tr><td>57083.1250</td><td>17</td></tr>
            <tr><td>456665.0000</td><td>18</td></tr>
        </MultiplierTable>

        <h4>8 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>1.3971</td><td>1</td></tr>
            <tr><td>2.0956</td><td>2</td></tr>
            <tr><td>3.2132</td><td>3</td></tr>
            <tr><td>5.0494</td><td>4</td></tr>
            <tr><td>8.1567</td><td>5</td></tr>
            <tr><td>13.5945</td><td>6</td></tr>
            <tr><td>23.4813</td><td>7</td></tr>
            <tr><td>42.2664</td><td>8</td></tr>
            <tr><td>79.8365</td><td>9</td></tr>
            <tr><td>159.6731</td><td>10</td></tr>
            <tr><td>342.1566</td><td>11</td></tr>
            <tr><td>798.3654</td><td>12</td></tr>
            <tr><td>2075.7500</td><td>13</td></tr>
            <tr><td>6227.2500</td><td>14</td></tr>
            <tr><td>22833.2500</td><td>15</td></tr>
            <tr><td>114166.2500</td><td>16</td></tr>
            <tr><td>1027496.2500</td><td>17</td></tr>
        </MultiplierTable>

        <h4>9 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>1.4844</td><td>1</td></tr>
            <tr><td>2.3750</td><td>2</td></tr>
            <tr><td>3.9018</td><td>3</td></tr>
            <tr><td>6.6030</td><td>4</td></tr>
            <tr><td>11.5553</td><td>5</td></tr>
            <tr><td>21.0096</td><td>6</td></tr>
            <tr><td>39.9183</td><td>7</td></tr>
            <tr><td>79.8365</td><td>8</td></tr>
            <tr><td>169.6526</td><td>9</td></tr>
            <tr><td>387.7775</td><td>10</td></tr>
            <tr><td>969.4437</td><td>11</td></tr>
            <tr><td>2714.4423</td><td>12</td></tr>
            <tr><td>8821.9375</td><td>13</td></tr>
            <tr><td>35287.7500</td><td>14</td></tr>
            <tr><td>194082.6250</td><td>15</td></tr>
            <tr><td>1940826.2500</td><td>16</td></tr>
        </MultiplierTable>

        <h4>10 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>1.5833</td><td>1</td></tr>
            <tr><td>2.7143</td><td>2</td></tr>
            <tr><td>4.8022</td><td>3</td></tr>
            <tr><td>8.8040</td><td>4</td></tr>
            <tr><td>16.8077</td><td>5</td></tr>
            <tr><td>33.6154</td><td>6</td></tr>
            <tr><td>70.9658</td><td>7</td></tr>
            <tr><td>159.6731</td><td>8</td></tr>
            <tr><td>387.7775</td><td>9</td></tr>
            <tr><td>1034.0733</td><td>10</td></tr>
            <tr><td>3102.2198</td><td>11</td></tr>
            <tr><td>10857.7692</td><td>12</td></tr>
            <tr><td>47050.3333</td><td>13</td></tr>
            <tr><td>282302.0000</td><td>14</td></tr>
            <tr><td>3105322.0000</td><td>15</td></tr>
        </MultiplierTable>

        <h4>11 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>1.6964</td><td>1</td></tr>
            <tr><td>3.1319</td><td>2</td></tr>
            <tr><td>6.0027</td><td>3</td></tr>
            <tr><td>12.0055</td><td>4</td></tr>
            <tr><td>25.2115</td><td>5</td></tr>
            <tr><td>56.0256</td><td>6</td></tr>
            <tr><td>133.0609</td><td>7</td></tr>
            <tr><td>342.1566</td><td>8</td></tr>
            <tr><td>969.4437</td><td>9</td></tr>
            <tr><td>3102.2198</td><td>10</td></tr>
            <tr><td>11633.3242</td><td>11</td></tr>
            <tr><td>54288.8462</td><td>12</td></tr>
            <tr><td>352877.5000</td><td>13</td></tr>
            <tr><td>4234530.0000</td><td>14</td></tr>
        </MultiplierTable>

        <h4>12 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>1.8269</td><td>1</td></tr>
            <tr><td>3.6538</td><td>2</td></tr>
            <tr><td>7.6399</td><td>3</td></tr>
            <tr><td>16.8077</td><td>4</td></tr>
            <tr><td>39.2179</td><td>5</td></tr>
            <tr><td>98.0449</td><td>6</td></tr>
            <tr><td>266.1218</td><td>7</td></tr>
            <tr><td>798.3654</td><td>8</td></tr>
            <tr><td>2714.4423</td><td>9</td></tr>
            <tr><td>10857.7692</td><td>10</td></tr>
            <tr><td>54288.8462</td><td>11</td></tr>
            <tr><td>380021.9231</td><td>12</td></tr>
            <tr><td>4940285.0000</td><td>13</td></tr>
        </MultiplierTable>

        <h4>13 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>1.9792</td><td>1</td></tr>
            <tr><td>4.3182</td><td>2</td></tr>
            <tr><td>9.9318</td><td>3</td></tr>
            <tr><td>24.2778</td><td>4</td></tr>
            <tr><td>63.7292</td><td>5</td></tr>
            <tr><td>182.0833</td><td>6</td></tr>
            <tr><td>576.5972</td><td>7</td></tr>
            <tr><td>2075.7500</td><td>8</td></tr>
            <tr><td>8821.9375</td><td>9</td></tr>
            <tr><td>47050.3333</td><td>10</td></tr>
            <tr><td>352877.5000</td><td>11</td></tr>
            <tr><td>4940285.0000</td><td>12</td></tr>
        </MultiplierTable>

        <h4>14 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>2.1591</td><td>1</td></tr>
            <tr><td>5.1818</td><td>2</td></tr>
            <tr><td>13.2424</td><td>3</td></tr>
            <tr><td>36.4167</td><td>4</td></tr>
            <tr><td>109.2500</td><td>5</td></tr>
            <tr><td>364.1667</td><td>6</td></tr>
            <tr><td>1383.8333</td><td>7</td></tr>
            <tr><td>6227.2500</td><td>8</td></tr>
            <tr><td>35287.7500</td><td>9</td></tr>
            <tr><td>282302.0000</td><td>10</td></tr>
            <tr><td>4234530.0000</td><td>11</td></tr>
        </MultiplierTable>

        <h4>15 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>2.3750</td><td>1</td></tr>
            <tr><td>6.3333</td><td>2</td></tr>
            <tr><td>18.2083</td><td>3</td></tr>
            <tr><td>57.2262</td><td>4</td></tr>
            <tr><td>200.2917</td><td>5</td></tr>
            <tr><td>801.1667</td><td>6</td></tr>
            <tr><td>3805.5417</td><td>7</td></tr>
            <tr><td>22833.2500</td><td>8</td></tr>
            <tr><td>194082.6250</td><td>9</td></tr>
            <tr><td>3105322.0000</td><td>10</td></tr>
        </MultiplierTable>

        <h4>16 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>2.6389</td><td>1</td></tr>
            <tr><td>7.9167</td><td>2</td></tr>
            <tr><td>26.0119</td><td>3</td></tr>
            <tr><td>95.3770</td><td>4</td></tr>
            <tr><td>400.5833</td><td>5</td></tr>
            <tr><td>2002.9167</td><td>6</td></tr>
            <tr><td>12685.1389</td><td>7</td></tr>
            <tr><td>114166.2500</td><td>8</td></tr>
            <tr><td>1940826.2500</td><td>9</td></tr>
        </MultiplierTable>

        <h4>17 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>2.9688</td><td>1</td></tr>
            <tr><td>10.1786</td><td>2</td></tr>
            <tr><td>39.0179</td><td>3</td></tr>
            <tr><td>171.6786</td><td>4</td></tr>
            <tr><td>901.3125</td><td>5</td></tr>
            <tr><td>6008.7500</td><td>6</td></tr>
            <tr><td>57083.1250</td><td>7</td></tr>
            <tr><td>1027496.2500</td><td>8</td></tr>
        </MultiplierTable>

        <h4>18 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>3.3929</td><td>1</td></tr>
            <tr><td>13.5714</td><td>2</td></tr>
            <tr><td>62.4286</td><td>3</td></tr>
            <tr><td>343.3571</td><td>4</td></tr>
            <tr><td>2403.5000</td><td>5</td></tr>
            <tr><td>24035.0000</td><td>6</td></tr>
            <tr><td>456665.0000</td><td>7</td></tr>
        </MultiplierTable>

        <h4>19 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>3.9583</td><td>1</td></tr>
            <tr><td>19.0000</td><td>2</td></tr>
            <tr><td>109.2500</td><td>3</td></tr>
            <tr><td>801.1667</td><td>4</td></tr>
            <tr><td>8412.2500</td><td>5</td></tr>
            <tr><td>168245.0000</td><td>6</td></tr>
        </MultiplierTable>

        <h4>20 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>4.7500</td><td>1</td></tr>
            <tr><td>28.5000</td><td>2</td></tr>
            <tr><td>218.5000</td><td>3</td></tr>
            <tr><td>2403.5000</td><td>4</td></tr>
            <tr><td>50473.5000</td><td>5</td></tr>
        </MultiplierTable>

        <h4>21 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>5.9375</td><td>1</td></tr>
            <tr><td>47.5000</td><td>2</td></tr>
            <tr><td>546.2500</td><td>3</td></tr>
            <tr><td>12017.5000</td><td>4</td></tr>
        </MultiplierTable>

        <h4>22 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>7.9167</td><td>1</td></tr>
            <tr><td>95.0000</td><td>2</td></tr>
            <tr><td>2185.0000</td><td>3</td></tr>
        </MultiplierTable>

        <h4>23 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>11.8750</td><td>1</td></tr>
            <tr><td>285.0000</td><td>2</td></tr>
        </MultiplierTable>

        <h4>24 Mines Multipliers</h4>
        <MultiplierTable>
            <tr><th>Multiplier</th><th>Gems uncovered</th></tr>
            <tr><td>23.7500</td><td>1</td></tr>
        </MultiplierTable>
    </div>
